<template>
  <div>
    <EditForm
      ref="editForm"
      :disabled="isDisableEditForm"
      :devTrackingCode="params.devTrackingCode"
    />
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'customerManage-selectionTracking-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
}
</script>
<style lang="scss">
.bg-transparent {
  .layout-theme-container-main-body {
    padding-top: 0px !important;
  }
}
</style>